import axios from "axios";
import { getCookie } from "../utils/cookieUtils";

const emailTemplateApiBaseUrl = import.meta.env.VITE_EMAIL_TEMPLATE_API;

const emailTemplateApi = axios.create({
  baseURL: emailTemplateApiBaseUrl,
});

emailTemplateApi.interceptors.request.use((config) => {
  const token = getCookie("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

interface TemplateEmailRequest {
  template_schema: string;
  recipients: string[];
  subject: string;
  data: Record<string, string>; // Data for template interpolation
}

interface Attachment {
  filename: string;
  content: string; // Base64 encoded content
  mime_type: string;
}

export interface EmailRequest {
  recipients: string[];
  subject: string;
  body: string;
  html_template?: string; // Optional HTML template
  attachments?: Attachment[];
}

// Function to send an email with a template
export const sendTemplateEmail = async (
  templateEmailRequest: TemplateEmailRequest
): Promise<void> => {
  try {
    const response = await emailTemplateApi.post(
      "/api/template/send",
      templateEmailRequest
    );
    return response.data;
  } catch (error) {
    console.error("Error sending template email", error);
    throw new Error("Failed to send template email");
  }
};

// Existing function to send a regular email
export const sendEmail = async (emailRequest: EmailRequest): Promise<void> => {
  try {
    const response = await emailTemplateApi.post(
      "/api/email/send",
      emailRequest
    );
    return response.data;
  } catch (error) {
    console.error("Error sending email", error);
    throw new Error("Failed to send email");
  }
};
